import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

export const isSupabaseConfigured = Boolean(url && key && !url.includes('YOUR_PROJECT'))
export const supabase = isSupabaseConfigured ? createClient(url, key) : null

export const CREDIT_EUR_VALUE = 10
export const PROJECT_STATUSES = {
  draft: 'Draft',
  submitted: 'Submitted',
  azimuth_review: 'Azimuth review',
  awaiting_customer_approval: 'Awaiting approval',
  in_design: 'In design',
  revision_requested: 'Revision requested',
  delivered: 'Delivered',
  closed: 'Closed',
  cancelled: 'Cancelled',
}

export const demoProjects = [
  { id: 'PV-1048', reference_name: 'Westbridge Logistics Roof', project_type: 'Commercial rooftop', capacity_kwp: 250, status: 'in_design', credits: 18, deadline: '2026-08-26', updated_at: '2026-08-18T11:20:00Z' },
  { id: 'PV-1044', reference_name: 'Meadow Lane Housing', project_type: 'Residential portfolio', capacity_kwp: 42, status: 'awaiting_customer_approval', credits: 9, deadline: '2026-08-23', updated_at: '2026-08-18T09:30:00Z' },
  { id: 'PV-1037', reference_name: 'Northport Office', project_type: 'Commercial rooftop', capacity_kwp: 86, status: 'revision_requested', credits: 12, deadline: '2026-08-20', updated_at: '2026-08-17T15:05:00Z' },
  { id: 'PV-1029', reference_name: 'Harbour View Retail', project_type: 'Commercial rooftop', capacity_kwp: 114, status: 'delivered', credits: 15, deadline: '2026-08-14', updated_at: '2026-08-14T16:40:00Z' },
]
